'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hoursFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hoursFromNow.js
// module id = 684
// module chunks = 0